import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "@/lib/api";

// Native push registration (Capacitor). No-op on web (keeps VAPID web push).
export async function registerNativePush(onOpen) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    let perm = await PushNotifications.checkPermissions();
    if (perm.receive === "prompt") perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;

    if (Capacitor.getPlatform() === "android") {
      await PushNotifications.createChannel({
        id: "default", name: "General", description: "jeeo notifications",
        importance: 5, sound: "default", vibration: true,
      });
    }

    await PushNotifications.addListener("registration", async (token) => {
      try {
        await api.post("/me/device-tokens", {
          platform: Capacitor.getPlatform(), token: token.value,
        });
      } catch (e) { console.error("save device token failed", e); }
    });
    await PushNotifications.addListener("registrationError", (e) => console.error("push reg error", e));
    await PushNotifications.addListener("pushNotificationActionPerformed", (a) => onOpen && onOpen(a));

    await PushNotifications.register();
  } catch (e) {
    console.error("registerNativePush failed", e);
  }
}
